import {
  FormControl,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/Info";
import MapIcon from "@mui/icons-material/Map";
import { useState } from "react";
import DeliveryInfoBox from "../../deliveryInformation/deliveryInfoBox";
import { GLOBAL_CONFIGURATION } from "../../../constants";

const PickupOrEatin = ({ control }) => {
  const { t } = useTranslation();
  return (
    <Controller
      name="eatin"
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl>
          <RadioGroup
            value={value}
            onChange={onChange}
            aria-labelledby="istimedelivery-label"
            name="istimedelivery"
          >
            <FormControlLabel
              value="false"
              control={<Radio />}
              label={t("Hent og ta med")}
            />
            <FormControlLabel
              value="true"
              control={<Radio />}
              label={t("Spis inne")}
            />
          </RadioGroup>
        </FormControl>
      )}
    />
  );
};

const PickupOrDelivery = ({ control, formData }) => {
  const [showDeliveryInfo, setShowDeliveryInfo] = useState(false);
  const { t } = useTranslation();
  const deliveryLocationDesc =
    GLOBAL_CONFIGURATION.deliveryLocationDescription ?? "Leveres til";
  const showDeliveryLocation = (formData || {}).isDelivery === "true";

  return (
    <>
      <Controller
        name="isDelivery"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <FormControl>
            <RadioGroup
              value={value}
              onChange={onChange}
              aria-labelledby="isDelivery-label"
              name="isDelivery"
            >
              <FormControlLabel
                value="false"
                control={<Radio />}
                label={
                  <>
                    {t("Hent på stasjon")}
                    {GLOBAL_CONFIGURATION.deliveryInformationMap && (
                      <Button
                        size="small"
                        color="info"
                        startIcon={<MapIcon />}
                        sx={{ marginLeft: 2 }}
                        href={GLOBAL_CONFIGURATION.deliveryInformationMap}
                        target="_blank"
                      >
                        Directions
                      </Button>
                    )}
                  </>
                }
              />
              <FormControlLabel
                value="true"
                control={<Radio />}
                label={
                  <>
                    {t("Levering på dør")}
                    {GLOBAL_CONFIGURATION.deliveryInformationCode ===
                      "KLINGENBERG" && (
                      <Button
                        size="small"
                        color="info"
                        startIcon={<InfoIcon />}
                        sx={{ marginLeft: 2 }}
                        onClick={() => setShowDeliveryInfo(!showDeliveryInfo)}
                      >
                        Only between 21:00 and 22:00
                      </Button>
                    )}
                  </>
                }
              />
            </RadioGroup>
          </FormControl>
        )}
      />
      {showDeliveryLocation && (
        <Controller
          name="deliveryLocation"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <FormControl>
              <TextField
                id="deliveryLocation"
                label={t(deliveryLocationDesc)}
                value={value}
                onChange={onChange}
                variant="outlined"
              />
            </FormControl>
          )}
        />
      )}
      {showDeliveryInfo && <DeliveryInfoBox alwaysShowMore={true} />}
    </>
  );
};

const CheckoutStep2 = (props) => {
  const { t } = useTranslation();
  const { step, hasInPrice, formData } = props;
  const showDeliveryLocation =
    (formData || {}).eatin !== "true" &&
    GLOBAL_CONFIGURATION.allowDeliveryOrders === true;

  return (
    <>
      <Typography variant="h5" component="h2" sx={{ padding: "15px" }}>
        {step}. {t("Spis inne eller ta med?")}
      </Typography>
      {hasInPrice && <PickupOrEatin {...props} />}
      {showDeliveryLocation && <PickupOrDelivery {...props} />}
    </>
  );
};

export default CheckoutStep2;
